/* ===== DECONOVO CMM ENHANCEMENTS v5 2026-07-01 ===== */
/* Section 1: CMM Step Title Override (measurement-tool page only)
   Section 2: Pinch Pleat Width Warning (product pages only)
   NOTE: Results page email panel removed per user request — keep original CMM results logic.
*/

;(function () {
  'use strict';

  /* ============================================================
     SECTION 1: CMM Step Title Fix
     Runs only on /pages/measurement-tool
     Root cause: title text is a TEXT NODE inside div.title.
     Fix: TreeWalker to find text nodes directly.
     DOM order of "Select Your Desired Fullness" nodes:
       index 0 = Step 6 Fullness (correct — skip)
       index 1 = Step 7 Finished Length (fix)
       index 2 = Results page (fix)
     ============================================================ */
  if (window.location.pathname.indexOf('/pages/measurement-tool') !== -1) {

    function fixTitles() {
      var nodes = [];
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      while (walker.nextNode()) {
        var v = walker.currentNode.nodeValue;
        if (v && v.trim() === 'Select Your Desired Fullness') {
          nodes.push(walker.currentNode);
        }
      }
      if (nodes[1] && nodes[1].nodeValue.trim() === 'Select Your Desired Fullness') {
        nodes[1].nodeValue = 'Choose Your Finished Length Style';
      }
      if (nodes[2] && nodes[2].nodeValue.trim() === 'Select Your Desired Fullness') {
        nodes[2].nodeValue = 'Your Recommended Size to Order';
      }
    }

    var observer = new MutationObserver(fixTitles);

    function init() {
      fixTitles();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      setInterval(fixTitles, 800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  /* ============================================================
     SECTION 2: Pinch Pleat Product Page Width Warning
     Runs only on /products/* pages where h1 contains "Pinch Pleat"
     ============================================================ */
  if (window.location.pathname.indexOf('/products/') !== -1) {

    function injectPinchPleatWarning() {
      if (document.getElementById('deco-pinch-warning')) return;

      var titleEl = document.querySelector('h1.product__title,h1[class*="product"],.product-title h1,.product-single__title,[class*="product"] h1,h1');
      if (!titleEl) return;
      if (titleEl.textContent.toLowerCase().indexOf('pinch pleat') === -1) return;

      var warning = document.createElement('div');
      warning.id = 'deco-pinch-warning';
      warning.setAttribute('style', 'margin:8px 0 16px;padding:10px 14px;background:#fff8e6;border-left:4px solid #e6a817;border-radius:0 4px 4px 0;font-size:12.5px;line-height:1.6;color:#5a4a2a;');
      warning.innerHTML = [
        '<strong>⚠️ Important — Pinch Pleat Width:</strong> ',
        'The width you select is the <strong>flat fabric width before pleating</strong>. ',
        'After the pleats are sewn, the finished top width will be approximately ',
        '<strong>half of the selected width, plus about 1 inch</strong>.<br>',
        '<em>Example: To achieve a ~50&rdquo; finished top width, select approximately 100&rdquo; width per panel.</em>'
      ].join('');

      // Try to insert after the Width option row
      var inserted = false;
      var allLabels = document.querySelectorAll('label,[class*="option-label"],[class*="variant-label"],[class*="form__label"],[class*="selector-label"]');
      for (var i = 0; i < allLabels.length; i++) {
        var labelText = allLabels[i].textContent.trim().toLowerCase();
        if (labelText.indexOf('width') === 0 || labelText === 'width') {
          var parent = allLabels[i].closest('.product-form__row,.selector-wrapper,.variant-field,.form-field,.product-option') || allLabels[i].parentNode;
          if (parent && parent.nextSibling) {
            parent.parentNode.insertBefore(warning, parent.nextSibling);
          } else if (parent) {
            parent.parentNode.appendChild(warning);
          }
          inserted = true;
          break;
        }
      }

      if (!inserted) {
        // Fallback: before Add to Cart
        var addToCart = document.querySelector('button[name="add"],[class*="add-to-cart"],[class*="product-form__submit"],button[type="submit"]');
        if (addToCart) {
          addToCart.insertAdjacentElement('beforebegin', warning);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectPinchPleatWarning);
    } else {
      injectPinchPleatWarning();
    }
    setTimeout(injectPinchPleatWarning, 1000);
  }

})();
/* ===== DECONOVO CMM ENHANCEMENTS v5 END ===== */